var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/emoji-selector/emoji-selector.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import React from 'react';
import { EmojiPickerModal, getCustomEmojis } from 'soapbox/components/emoji_picker';
import { Emoji, HStack } from 'soapbox/components/ui';
import { useAppSelector, useFeatures } from 'soapbox/hooks';
/** Clickable emoji button that scales when hovered. */
const EmojiButton = ({
  emoji,
  className,
  onClick,
  tabIndex
}) => {
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(className),
    onClick: onClick,
    tabIndex: tabIndex,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    className: "w-8 h-8 duration-100 hover:scale-125",
    emoji: emoji,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }));
};
/** Panel with a row of emoji buttons. */
const EmojiSelector = ({
  emojis,
  onReact,
  visible = false,
  focused = false,
  meEmojiReact
}) => {
  const [modalActive, setModalActive] = React.useState(false);
  const custom_emojis = useAppSelector(state => getCustomEmojis(state));
  const features = useFeatures();
  const handleReact = React.useCallback(emoji => {
    return e => {
      e.preventDefault();
      e.stopPropagation();
      onReact(emoji);
    };
  }, [onReact]);
  const handleOpenCustomReact = React.useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    setModalActive(true);
  }, []);
  const handleUnReact = React.useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    onReact(meEmojiReact.get('name'));
  }, [onReact, meEmojiReact]);
  const handleCustomReact = React.useCallback(emoji => {
    onReact(emoji.native);
  }, [onReact]);
  const onCloseModal = React.useCallback(() => {
    setModalActive(false);
    onReact(null);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    className: classNames('bg-white dark:bg-slate-900 p-3 rounded-full shadow-md z-[999] w-max'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 7
    }
  }, Array.from(emojis).map((emoji, i) => /*#__PURE__*/React.createElement(EmojiButton, {
    key: i,
    emoji: emoji,
    onClick: handleReact(emoji),
    tabIndex: visible || focused ? 0 : -1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86,
      columnNumber: 11
    }
  })), features.emojiCustomReacts && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 15
    }
  }), !meEmojiReact ? /*#__PURE__*/React.createElement(EmojiButton, {
    emoji: '➕',
    onClick: handleOpenCustomReact,
    tabIndex: visible || focused ? 0 : -1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 19
    }
  }) : /*#__PURE__*/React.createElement(EmojiButton, {
    emoji: '➖',
    onClick: handleUnReact,
    tabIndex: visible || focused ? 0 : -1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 19
    }
  }))), features.emojiCustomReacts && /*#__PURE__*/React.createElement("div", {
    onClick: e => e.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(EmojiPickerModal, {
    custom_emojis: custom_emojis,
    active: modalActive,
    onClose: onCloseModal,
    onPickEmoji: handleCustomReact,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 13
    }
  })));
};
export default EmojiSelector;